frappe.ui.form.ControlCurrency = frappe.ui.form.ControlFloat.extend({
	format_for_input: function(value) {
		var formatted_value = format_number(value, this.get_number_format(), this.get_precision());
		//UDI START - Ricky 20210521 - https://github.com/frappe/frappe/pull/13011
		//Original Code START - Ricky 20210521
		//return isNaN(parseFloat(value)) ? "" : formatted_value;
		//Original Code END - Ricky 20210521
		
		//Changes START - Ricky 20210521
		return isNaN(Number(value)) ? "" : formatted_value;
		//Changes END - Ricky 20210521
		//UDI END - Ricky 20210521 - https://github.com/frappe/frappe/pull/13011
	},

	get_precision: function() {
		// always round based on field precision or currency's precision
		// this method is also called in this.parse()
		if (!this.df.precision) {
			if(frappe.boot.sysdefaults.currency_precision) {
				this.df.precision = frappe.boot.sysdefaults.currency_precision;
			} else {
				this.df.precision = get_number_format_info(this.get_number_format()).precision;
			}
		}

		return this.df.precision;
	}
});
